<template>
  <section>
    <Observer name="fade-up">
      <div class="text-center">
        <h2 class="title -upper">{{ $t('Technical features') }}</h2>
      </div>
    </Observer>
    <Observer name="fade-up">
      <div class="container">
        <hooper :settings="hooperSettings" ref="carousel" @slide="updateProgress" tabindex="-1">
          <slide>
            <div>
              <img src="../assets/icons/font/diameter.svg" :alt="$t('Diameter')">
              <span class="number">
                <ICountUp :delay="iCountUp.delay" :endVal="+item.diameter" ref="diameter" :options="iCountOptions(item.diameter.toString())" />
                <sub><span class="only-ssr">{{ item.diameter.toString() }}</span> {{ $t('MM') }}</sub>
              </span>
            </div>
            <strong>{{ $t('Diameter') }}</strong>
          </slide>
          <slide>
            <div>
              <img src="../assets/icons/font/frequency.svg" :alt="$t('Frequency')">
              <span class="number">
                <ICountUp :delay="iCountUp.delay" :endVal="+item.frequency" ref="frequency" :options="iCountOptions(item.frequency.toString())" />
                <sub><span class="only-ssr">{{ item.frequency.toString() }}</span> {{ $t('VpH') }}</sub>
              </span>
            </div>
            <strong>{{ $t('Frequency') }}</strong>
          </slide>
          <slide>
            <div>
              <img src="../assets/icons/font/power.svg" :alt="$t('Power Reserve')">
              <span class="number">
                <ICountUp :delay="iCountUp.delay" :endVal="+item.powerReserve" ref="powerReserve" :options="iCountOptions(item.powerReserve.toString())"/>
                <sub><span class="only-ssr">{{ item.powerReserve.toString() }}</span> {{ $t('H') }}</sub>
              </span>
            </div>
            <strong>{{ $t('Power Reserve') }}</strong>
          </slide>
          <slide>
            <div>
              <img src="../assets/icons/font/water.svg" :alt="$t('Water Resistance')">
              <span class="number">
                <ICountUp :delay="iCountUp.delay" :endVal="+item.waterResistance" ref="waterResistance" :options="iCountOptions(item.waterResistance.toString())"/>
                <sub><span class="only-ssr">{{ item.waterResistance.toString() }}</span> {{ $t('ATM') }}</sub>
              </span>
            </div>
            <strong>{{ $t('Water Resistance') }}</strong>
          </slide>
        </hooper>
        <ul ref="progress" class="progress">
          <li :class="{'-active': currentSlide === 0}">
            <button type="button" @click="slideTo(0)" :aria-label="progressAriaLabel(0)"></button>
          </li>
          <li :class="{'-active': currentSlide === 1}">
            <button type="button" @click="slideTo(1)" :aria-label="progressAriaLabel(1)"></button>
          </li>
          <li :class="{'-active': currentSlide === 2}">
            <button type="button" @click="slideTo(2)" :aria-label="progressAriaLabel(2)"></button>
          </li>
          <li :class="{'-active': currentSlide === 3}">
            <button type="button" @click="slideTo(3)" :aria-label="progressAriaLabel(3)"></button>
          </li>
        </ul>
      </div>
    </Observer>
  </section>
</template>

<script>
import ICountUp from 'vue-countup-v2'
import { Hooper, Slide } from 'hooper'
// import 'hooper/dist/hooper.css'
import { ReadyHook } from 'vue-asyncready'

export default {
  props: ['item', 'pagePosition', 'siblings-components'],
  name: 'technical_specification_hero',
  mixins: [ReadyHook],
  components: {
    Hooper,
    Slide,
    ICountUp
  },
  data() {
    return {
      currentSlide: 0,
      hooperSettings: {
        initialSlide: 0,
        itemsToShow: 1,
        itemsToSlide: 1,
        transition: 400,
        autoPlay: false,
        mouseDrag: true,
        shortDrag: true,
        touchDrag: true,
        hoverPause: false,
        keysControl: true,
        wheelControl: false,
        trimWhiteSpace: true,
        infiniteScroll: false,
        breakpoints: {
          768: {
            itemsToShow: 4,
            itemsToSlide: 4,
            mouseDrag: false,
            shortDrag: false,
            touchDrag: false,
            keysControl: false,
            trimWhiteSpace: false
          }
        }
      },
      iCountUp: {
        instance: null,
        delay: 0
      }
    }
  },
  methods: {
    slideTo (i) {
      this.$refs.carousel.slideTo(i)
    },
    updateProgress (payload) {
      this.currentSlide = payload.currentSlide
    },
    progressAriaLabel (i) {
      return (this.currentSlide === i) ? this.$t('Slide') + ' ' + i + ' ' + this.$t('(current slide)') : this.$t('Slide') + ' ' + i
    },
    isVisible () {
      if (window.pageYOffset + window.innerHeight > this.$el.offsetTop + this.$el.offsetHeight) {
        window.removeEventListener('scroll', this.isVisible)
        this.$refs.diameter.start()
        this.$refs.frequency.start()
        this.$refs.powerReserve.start()
        this.$refs.waterResistance.start()
      } else {
        this.$refs.diameter.reset()
        this.$refs.frequency.reset()
        this.$refs.powerReserve.reset()
        this.$refs.waterResistance.reset()
      }
    },
    iCountOptions (v) {
      v = v.split('.')
      return {
        useEasing: true,
        useGrouping: false,
        separator: ',',
        decimal: '.',
        prefix: '',
        suffix: '',
        decimalPlaces: v[1] ? v[1].length : 0
      }
    }
  },
  mounted () {
    this.isVisible()
    window.addEventListener('scroll', this.isVisible)
  },
  destroyed: function () {
    window.removeEventListener('scroll', this.isVisible)
  }
}
</script>

<style lang="scss" scoped>
@import "~theme/css/core";

section {
  margin-top: 10rem;

  .h2 {
    color: var(--zenith-component-title-secondary);
  }
}

.-icons .title {
  display: inline;
  color: var(--zenith-white) !important;
  background: var(--zenith-theme-primary) !important;
  box-shadow: -2px 0px 0px 6px var(--zenith-theme-primary);
}

.hooper {
  max-width: 110rem;
  margin: 6rem auto 10rem;
  height: auto;
  color: var(--zenith-component-title-secondary);

  &-slide {
    text-align: center;

    div {
      position: relative;
      margin-bottom: 4rem;
      @include bp(max md) {
        margin-bottom: 1rem;
      }
    }

    img {
      display: block;
      width: 100%;
      opacity: var(--zenith-component-technical-specification-hero-img-opacity)
    }

    .number {
      position: absolute;
      top: 50%;
      left: 50%;
      font-size: em(60);
      line-height: 9rem;
      letter-spacing: em(3, 100);
      transform: translate(-50%, -50%);

      @include bp(max lg) {
        font-size: em(50);
        line-height:5rem;
        letter-spacing: em(3, 50);
      }

      @include bp(max md) {
        font-size: em(80);
        line-height:9rem;
        letter-spacing: em(3, 80);
      }

      sub {
        position: absolute;
        font-size: em(18, 100);
        right: 0;
        top: 85%;
        line-height: normal;
        text-align: left;
        transform: translateX(50%);
      }

      .only-ssr {
        display: none;
      }
    }

    strong {
      display: block;
      font-size: em(18);
      text-transform: uppercase;

      @include bp(max md) {
        margin-bottom: 4rem;
      }
    }
  }
}

.progress {
  position: absolute;
  display: none;
  bottom: 10rem;
  z-index: 50;
  max-width: 50rem;
  width: 80%;
  padding: 0;
  margin: 0;
  left: 50%;
  transform: translateX(-50%);
  list-style: none;
  text-align: center;
  table-layout: fixed;
  border-spacing: 2rem 0;
  border-collapse: separate;

  @include bp(max md) {
    display: table;
    width: 100%;
    bottom: -3rem;
  }

  li {
    width: 100%;
    display: table-cell;

    button {
      position: relative;
      height: 4rem;
      width: 100%;
      padding: 0;
      border: none;
      display: block;
      background: transparent;
      overflow: hidden;

      &:before {
        content: '';
        display: block;
        position: absolute;
        z-index: 5;
        top: 50%;
        left: 0;
        width: 100%;
        height: .2rem;
        background: var(--zenith-btn-disabled);
        border-radius: 2px;
      }
      &:after {
        content: '';
        display: block;
        position: absolute;
        z-index: 10;
        top: 50%;
        left: 0;
        width: 0;
        height: .2rem;
        background: var(--zenith-theme-primary);
        border-radius: 2px;
      }

    }

    &.-active button:after {
      width: 100%;
      transition: 0.2s width ease-in-out;
    }
  }
}
</style>
